import type { FC } from 'react';
import type { HeaderProps } from './types';
import { withChildren } from '@builder.io/react';
import { useColorProvider } from '@/utils/ColorProvider';
import { cls } from '@/utils/cls';
import style from './Header.module.scss';
import RichText from '../RichText';
const Header: FC<HeaderProps> = ({
  extendStyles,
  copy,
  logo,
  mobileStack = true,
  mobileButton = true,
  mobileText = true,
  mobileLogo = true,
  children,
  usePageColors = true,
  backgroundColor,
  textColor
}) => {
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  const imageSrc = logo && logo.value ? logo.value.data.image : '/TotalInjuryHelp_logo.webp';
  const hasButton = !!children && !!children.length;
  const _backgroundColor = usePageColors ? colors.primaryAccentColor : backgroundColor;
  const _textColor = usePageColors ? 'white' : textColor;

  // show text if no elements are selected to avoid empty header
  const showMobileText = mobileText || !mobileButton && !mobileText && !mobileLogo;
  return <div className={_className} style={{
    backgroundColor: _backgroundColor || '#525252',
    color: _textColor || 'white'
  }} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
			<div className={!mobileStack ? style.wrapperRow : style.wrapper} data-grid>
				<img className={mobileLogo ? style.logo : cls(style.logo, style.mobileHide)} src={imageSrc} alt={logo?.value?.data.name || ''} role="presentation" />
				<RichText text={copy} className={showMobileText ? style.copy : cls(style.copy, style.mobileHide)} data-sentry-element="RichText" data-sentry-source-file="Header.tsx" />
				<div className={mobileButton ? style.button : cls(style.button, style.mobileHide)}>
					{' '}
					{hasButton && children}
				</div>
			</div>
		</div>;
};
export default withChildren(Header);